import { createAction } from 'redux-act';

export const fetchTreatments = createAction('split/FETCH_TREATMENTS');
export const setTreatments = createAction('split/SET_TREATMENTS');
export const registerSplits = createAction('split/REGISTER_SPLITS');
export const trackEvent = createAction('split/TRACK_EVENT');
export const emitSplitTreatments = createAction('split/TRACK_SPLIT_TREATMENTS_IN_GTM');
export const setIsVip = createAction('split/SET_IS_VIP');
